import Img1 from "../../images/Black-Friday-Web.jpg";
import Img2 from "../../images/Feed-The-Tribe-Oct.jpg";

export const dealData = [
  {
    img: Img1,
    alt: "black friday specials",
    desc:
      "Get your pizza for as low as N3000 during our black friday special. Get all your favorites delivered to your doorstep on Jumia food.",
    button: "Order Now",
    title: "Black Friday Special",
  },
  {
    img: Img2,
    alt: "Feed The Tribe",
    desc:
      "Get your pizza for as low as N9900 during with our Feed The Tribe special. Get all your favorites delivered to your doorstep on Jumia food.",
    button: "Order Now",
    title: "Feed The Tribe",
  },
];
